import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const TranslationsStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>Translations Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
